@if (isEnrolling$ | async) {
<p>Follow the instructions to install the enrollment profile.</p>
} @else {
<era-pairing-challenge-ui [challenge]="pairingChallenge$ | async"
                          (enroll)="enroll($event)"></era-pairing-challenge-ui>
} @if (isVerifyingCode$ | async) {
<p>
  Verifying code
  <ml-sk-spinner-3 class="compact"></ml-sk-spinner-3>
</p>
} @else if (isCodeInvalid$ | async) {
<p class="text-danger">
  The code has expired;<br />
  or is invalid.
</p>
} @else if (isEnrollCompleted$ | async) {
<p class="text-success">The device has been successfully enrolled.</p>
} @else if (error$ | async) {
<p class="text-danger">
  An error occured. @if (this.environmentService.environment.local) {
  <span>Please check if the certificate is trusted.</span>
  }
</p>
} @if (this.environmentService.environment.local) {
<p>
  <a [attr.href]="this.ca"
     class="text-white">Download the Rocksoft CA certificate</a>
</p>
}